import React from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import { FaHandPointRight } from 'react-icons/fa';
import { MainLayout } from '../../layouts';
import { Contributors } from './components';
import {
  StyledIntroductionWrapper,
  StyledContainer,
  StyledTitle,
  StyledDescription,
  ItalicText,
  CenterAlignText,
  StyledLink,
} from './Home.styled';

const features = [
  { title: 'Easy_Use', description: 'Easy_Use_Description' },
  { title: 'Many_Utilities', description: 'Many_Utilities_Description' },
  { title: 'Free', description: 'Free_Description' },
];

const Home = (props) => {
  const { t } = useTranslation();
  return (
    <MainLayout>
      <StyledIntroductionWrapper>
        <StyledContainer>
          <Container>
            <StyledTitle>{t('Introduction_title')}</StyledTitle>

            <StyledDescription>
              <strong>{t('IntroductionHome1')}</strong> {t('IntroductionHome2')}{' '}
              <strong>{t('IntroductionHome3')}</strong> {t('IntroductionHome4')}{' '}
              <strong>{t('IntroductionHome5')}</strong> {t('IntroductionHome6')}{' '}
              <strong>{t('IntroductionHome7')}</strong> {t('IntroductionHome8')}{' '}
              <strong>{t('IntroductionHome9')}</strong>{' '}
              {t('IntroductionHome10')}
              <ul style={{ marginTop: 8 }}>
                <li>
                  <ItalicText>(i) {t('Outstanding_Solutions1')}</ItalicText>
                </li>
                <li>
                  <ItalicText>(ii) {t('Outstanding_Solutions2')}</ItalicText>
                </li>
                <li>
                  <ItalicText>(iii) {t('Outstanding_Solutions3')}</ItalicText>
                </li>
                <li>
                  <ItalicText>(iv) {t('Outstanding_Solutions4')}</ItalicText>
                </li>
                <li>
                  <ItalicText>(v) {t('Outstanding_Solutions5')}</ItalicText>
                </li>
              </ul>
            </StyledDescription>
          </Container>
        </StyledContainer>
      </StyledIntroductionWrapper>
      <main>
        <Container>
          <StyledTitle>{t('Feature_title')}</StyledTitle>
          <Grid container spacing={3}>
            {features.map((feature) => (
              <Grid item xs={12} md={4} key={feature.title}>
                <h3>{t(feature.title)}</h3>
                <FaHandPointRight /> <span>{t(feature.description)}</span>
              </Grid>
            ))}
          </Grid>
          <StyledTitle>{t('Software_Product_Title')}</StyledTitle>
          <CenterAlignText>{t('Software_Product_Description')}</CenterAlignText>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <h3>{t('UTrafficMobile')}</h3>
              <FaHandPointRight />{' '}
              <span>
                {t('UTrafficMobile_Description')}{' '}
                <StyledLink
                  href='https://bktraffic.com/home/mobile-app'
                  alt='#'
                  target='_blank'
                  rel='noreferrer'
                >
                  https://bktraffic.com/home/mobile-app
                </StyledLink>
                .
              </span>
            </Grid>
            <Grid item xs={12} md={6}>
              <h3>{t('UTrafficPortal')}</h3>
              <FaHandPointRight />{' '}
              <span>
                {t('UTrafficPortal_Description')}{' '}
                <StyledLink
                  href='https://bktraffic.com/utraffic/'
                  alt='#'
                  target='_blank'
                  rel='noreferrer'
                >
                  https://bktraffic.com/utraffic/
                </StyledLink>
                .
              </span>
            </Grid>
            <Grid item xs={12} md={6}>
              <h3>{t('UTrafficMIS')}</h3>
              <FaHandPointRight />{' '}
              <span>
                {t('UTrafficMIS_Description1')}
                {''}
                <strong>{t('UTrafficMIS_Description2')}</strong>
                {''}
                {t('UTrafficMIS_Description3')}
              </span>
            </Grid>
            <Grid item xs={12} md={6}>
              <h3>{t('PublishData_APIs_Documents')}</h3>
              <FaHandPointRight />{' '}
              <span>{t('PublishData_APIs_Documents_Description')}</span>
            </Grid>
          </Grid>
          <StyledTitle>{t('Members')}</StyledTitle>
          <Contributors />
        </Container>
      </main>
    </MainLayout>
  );
};

export default Home;
